import { ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components'
import { TEinvoiceReceived } from '@Arti-zen/package-backoffice'
import { ApiArtizenBO } from 'utils/artizenConnector'
import TableInfinite from 'components/table/infinite/InfiniteTable'
import DownloadButton from 'components/DownloadButton'
import { definitionFields } from './EinvoicingReceived.definitionFields'

export default function EinvoicingReceivedCtrl(): ReactElement {
  const [eInvoiceList, setEInvoiceList] = useState<TEinvoiceReceived[]>([])

  useEffect(() => {
    ApiArtizenBO.eInvoicing.getAllReceivedFromBdd().then((res) => setEInvoiceList(res))
  }, [])

  const onSelect = (item: TEinvoiceReceived) => {
    console.log(item)
  }

  return (
    <Wrapper>
      <Header>
        <DownloadButton data={eInvoiceList} fileName="eInvoices" label={null} size="medium" />
      </Header>
      <TableInfinite<TEinvoiceReceived>
        data={eInvoiceList}
        definitionFields={definitionFields({ onSelect })}
        nextPage={null}
        isQueriedAllCompleted={true}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 100px;
  margin-bottom: 20px;
`

const StatsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const StatsLabel = styled.td`
  padding-right: 15px;
`
const StatsValue = styled.td`
  font-weight: bold;
  text-align: center;
  background-color: lightgray;
  border-radius: 5px;
  padding: 2px;
  padding-left: 10px;
  padding-right: 10px;
`
